<template>
  <h1>[WIP] Seller: {{ route.params.sellerName }}</h1>

  <NuxtLink :to="`/${route.params.locale}`">Go back Home</NuxtLink>

  <!-- <Layout>
    <template #topLanding>
      <TopLanding />
    </template>
  </Layout> -->
</template>

<script lang="ts" setup>
import { useRoute } from 'nuxt/app'

const route = useRoute()
</script>
